import errorMessages from '../../const/errorMessages';
import ToasterService from '../ToasterService';
import * as _ from 'lodash';
import { IProject } from '../../models/IProject';
import { ICohort } from '../../models/ICohort';
import { Environment } from '../../const/environment';
import { getProjectOptionsByEnvironment } from './getProjectOptionsByEnvironment';
import { getBoolOption } from '../../views/pages/embed/getProjectOptions';

interface IOptionFormProps {
    project: IProject,
    platform: string,
    environment: Environment,
    cohorts: ICohort[],
    setProjectOptions: any
    selectedCohortId: string
    currentOptions?: any
}

export function toogleBooleanOption(
    props: IOptionFormProps,
    optionVal: boolean,
    changeStateCb: (newVal: boolean) => void,
    skipSaving: boolean,
    optionName: string,
    optionNameOld?: string,

): Promise<void | object> {
    const {
        project,
        platform,
        environment,
        cohorts,
        selectedCohortId,
        setProjectOptions,
        currentOptions
    } = props;

    const options = getProjectOptionsByEnvironment(project, platform, environment, cohorts, selectedCohortId);

    let expectedNewVal;

    if (_.isBoolean(optionVal)) {
        expectedNewVal = !optionVal;
    }

    return new Promise((resolve, reject) => {
        try {
            if (currentOptions) {
                options[platform] = currentOptions || {};
            }
            options[platform] = _.set(options[platform], optionName, expectedNewVal);

            // set old options' for back consistency 
            if (!_.isUndefined(options[platform][optionNameOld])) {
                options[platform] = _.set(options[platform], optionNameOld, expectedNewVal);
            }

            changeStateCb(expectedNewVal);
            if (skipSaving === true) {
                const newVal = _.get(options[platform], optionName);
                changeStateCb(newVal);
                resolve(options[platform]);
            } else {
                return setProjectOptions({ project, options, environment, cohorts, selectedCohortId }).then(
                    () => {
                    },
                    () => {
                        changeStateCb(getBoolOption(props, optionName));
                    }).then(() => {
                        resolve();
                    });
            }
        } catch (e) {
            reject();
        }
    });
}
